import Big from 'big.js';

Big.RM = 0;

export function getAsset(pair) {
  return pair.split('-')[1];
}

// truncates without rounding
export function truncate(number, maxDecimalPlaces = 0) {
  if (number === null || number === undefined || isNaN(number)) return null;
  if (number === Infinity) return number;
  const numString = new Big(number).toFixed();
  try {
    const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + maxDecimalPlaces + '})?', 'g'); // eslint-disable-line
    const truncated = numString.match(reg)[0];
    const decimalIndex = truncated.indexOf('.');
    if (decimalIndex === -1) {
      return `${truncated}.${'0'.repeat(maxDecimalPlaces)}`;
    }
    const missingFigs = maxDecimalPlaces - (truncated.length - decimalIndex) + 1;
    return missingFigs > 0 ? truncated + '0'.repeat(missingFigs) : truncated;
  } catch (err) {
    console.warn(`truncation error for ${number}, ${maxDecimalPlaces}:`, err); // eslint-disable-line
    return number;
  }
}

// Pass in an already truncated or formatted number
export function truncateTotalLength(number, maxLength) {
  let numString = `${number}`;
  let effectiveMaxLength = maxLength;
  const isDecimal = numString.includes('.');
  if (isDecimal) effectiveMaxLength += (numString.match(/\./g) || []).length;
  if (numString.length > effectiveMaxLength) {
    const toBeRemoved = numString.slice(effectiveMaxLength);
    if (parseFloat(toBeRemoved) === 0 && !toBeRemoved.includes('.') && isDecimal) {
      numString = numString.slice(0, effectiveMaxLength);
      if (numString.charAt(numString.length) === '.') numString = numString.slice(0, numString.length - 1);
    } else {
      numString = numString.slice(0, effectiveMaxLength - 1);
      if (numString.charAt(numString.length) === '.') numString = numString.slice(0, numString.length - 1);
      numString = `${numString}...`;
    }
  }
  return numString;
}

// Adds thousands separators
export function formatNumber(number) {
  if (number === undefined || isNaN(number)) return null;
  const numString = `${number}`;
  return numString.replace(/\B(?=(?=\d*\.)(\d{3})+(?!\d))/g, ',');
}

export function formatAndTruncate(number, minTickLength = 0) {
  return formatNumber(truncate(number, minTickLength));
}
